


























import OrderActionTableCell from '@/components/OrderActionTableCell.vue'
import { transportRequestStates as states } from '@/components/order-states'

export default {
  components: {
    OrderActionTableCell
  },
  props: {
    title: { type: String, default: '' },
    hSpan: { type: Number, default: 4 },
    hasSuggestedSpotCost: { type: Boolean, default: false },
    transportRequest: { type: Object, default: null }
  },
  computed: {
    actionButtonTitle() {
      return this.hasSuggestedSpotCost
        ? this.$t('marketPlace.acceptNow.button')
        : this.$t('marketPlace.actionCell.request')
    },
    hasTransportRequest() {
      return !!this.transportRequest?.id
    },
    transporRequestText() {
      return this.requestIsRejected
        ? this.$t('marketPlace.actionCell.orderStatus.rejectedOffer', {
            offerPrice: `${this.transportRequest?.price || 0}€`
          })
        : this.$t('marketPlace.actionCell.orderStatus.pendingOffer', {
            offerPrice: `${this.transportRequest?.price || 0}€`
          })
    },
    requestIsRejected() {
      return this.transportRequest?.state === states.rejected
    }
  }
}
